module.exports = function getResource(label) {
    const resources = { storeDetails: 'Store Details' };

    return resources[label];
};
